var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _path16, _g2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiwarehouseSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 82,
    viewBox: "0 0 83 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1024 54.2372C47.4748 54.2372 46.9915 53.7539 46.9915 53.1263H35.3035C35.3035 53.7539 34.8214 54.2372 34.2418 54.2372C33.6142 54.2372 33.1309 53.7539 33.1309 53.1263V47.6207C33.1309 46.9931 33.6142 46.5098 34.2418 46.5098H48.1024C48.682 46.5098 49.2134 46.9931 49.2134 47.6207V53.1263C49.2134 53.7539 48.682 54.2372 48.1024 54.2372Z",
    fill: "#367E97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4475 71.5764C68.868 71.5764 68.3366 71.0943 68.3366 70.5147V59.4063H56.5043C55.8767 59.4063 55.3934 58.9229 55.3934 58.3434C55.3934 57.7158 55.8767 57.2324 56.5043 57.2324H69.4475C70.0752 57.2324 70.5585 57.7158 70.5585 58.3434V70.5147C70.5585 71.0943 70.0752 71.5764 69.4475 71.5764ZM12.8942 71.5764C12.2653 71.5764 11.7832 71.0943 11.7832 70.5147V58.3434C11.7832 57.7158 12.2653 57.2324 12.8942 57.2324H25.8374C26.4169 57.2324 26.899 57.7158 26.899 58.3434C26.899 58.9229 26.4169 59.4063 25.8374 59.4063H13.9558V70.5147C13.9558 71.0943 13.4737 71.5764 12.8942 71.5764Z",
    fill: "#367E97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.59 43.9973H56.5049C55.8773 43.9973 55.394 43.5152 55.394 42.8876V38.9271C55.394 38.5892 55.1523 38.3475 54.8144 38.3475H27.5273C27.1894 38.3475 26.8996 38.5892 26.8996 38.9271V42.8876C26.8996 43.5152 26.4175 43.9973 25.838 43.9973H19.6074C11.9762 43.9973 5.79492 37.768 5.79492 30.1848C5.79492 23.7619 10.1414 18.2564 16.2745 16.7595C16.2264 16.228 16.1784 15.6966 16.1784 15.1171C16.1784 6.76199 22.9884 0 31.3435 0C36.7516 0 41.775 2.89764 44.431 7.48578C46.8465 5.65102 49.7923 4.63746 52.8342 4.63746C59.934 4.63746 65.8267 9.99749 66.5986 16.9518C72.4432 18.6904 76.4025 24.0036 76.4025 30.1848C76.4025 37.768 70.2213 43.9973 62.59 43.9973Z",
    fill: "#72E0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6671 38.3507C47.0876 38.3507 46.6055 37.8192 46.6055 37.2397V26.4691C46.6055 25.8415 47.0876 25.3594 47.6671 25.3594H54.6708C55.2503 25.3594 55.7324 25.8415 55.7324 26.4691C55.7324 27.098 55.2503 27.5801 54.6708 27.5801H48.7781V37.2397C48.7781 37.8192 48.296 38.3507 47.6671 38.3507Z",
    fill: "#367E97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6278 38.3507C34.0483 38.3507 33.5649 37.8192 33.5649 37.2397V27.5801H27.6735C27.0939 27.5801 26.5625 27.098 26.5625 26.4691C26.5625 25.8415 27.0939 25.3594 27.6735 25.3594H34.6278C35.2554 25.3594 35.7388 25.8415 35.7388 26.4691V37.2397C35.7388 37.8192 35.2554 38.3507 34.6278 38.3507Z",
    fill: "#367E97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1488 38.3498C40.5693 38.3498 40.0859 37.8183 40.0859 37.2388V22.2672C40.0859 21.6877 40.5693 21.1562 41.1488 21.1562C41.7764 21.1562 42.2598 21.6877 42.2598 22.2672V37.2388C42.2598 37.8183 41.7764 38.3498 41.1488 38.3498Z",
    fill: "#367E97"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4668 30.7161H55.7825C54.526 30.7161 53.5605 29.7507 53.5605 28.4942V24.4375C53.5605 23.1823 54.526 22.2168 55.7825 22.2168H60.4668C61.674 22.2168 62.6887 23.1823 62.6887 24.4375V28.4942C62.6887 29.7507 61.674 30.7161 60.4668 30.7161Z",
    fill: "#114A65"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5625 30.7161H21.8782C20.6217 30.7161 19.6562 29.7507 19.6562 28.4942V24.4375C19.6562 23.1823 20.6217 22.2168 21.8782 22.2168H26.5625C27.7697 22.2168 28.7844 23.1823 28.7844 24.4375V28.4942C28.7844 29.7507 27.7697 30.7161 26.5625 30.7161Z",
    fill: "#114A65"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5137 23.3748H38.8294C37.5729 23.3748 36.6074 22.36 36.6074 21.1529V17.0481C36.6074 15.8397 37.5729 14.8262 38.8294 14.8262H43.5137C44.7208 14.8262 45.7356 15.8397 45.7356 17.0481V21.1529C45.7356 22.36 44.7208 23.3748 43.5137 23.3748Z",
    fill: "#114A65"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8159 48.6823H27.5287C25.9837 48.6823 24.7285 47.4739 24.7285 45.9289V38.9265C24.7285 37.3802 25.9837 36.125 27.5287 36.125H54.8159C56.3622 36.125 57.6174 37.3802 57.6174 38.9265V45.9289C57.6174 47.4739 56.3622 48.6823 54.8159 48.6823Z",
    fill: "#114A65"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8159 64.6229H27.5287C25.9837 64.6229 24.7285 63.3677 24.7285 61.8215V54.819C24.7285 53.274 25.9837 52.0176 27.5287 52.0176H54.8159C56.3622 52.0176 57.6174 53.274 57.6174 54.819V61.8215C57.6174 63.3677 56.3622 64.6229 54.8159 64.6229Z",
    fill: "#114A65"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8615 45.4491C29.171 45.4491 27.8184 44.0977 27.8184 42.4072C27.8184 40.7648 29.171 39.4121 30.8615 39.4121C32.5039 39.4121 33.8553 40.7648 33.8553 42.4072C33.8553 44.0977 32.5039 45.4491 30.8615 45.4491Z",
    fill: "#EB3D31"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1025 45.4491C36.412 45.4491 35.0605 44.0977 35.0605 42.4072C35.0605 40.7648 36.412 39.4121 38.1025 39.4121C39.7449 39.4121 41.0975 40.7648 41.0975 42.4072C41.0975 44.0977 39.7449 45.4491 38.1025 45.4491Z",
    fill: "#FFD05C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4171 43.5156H44.0485C43.4689 43.5156 42.9375 43.0323 42.9375 42.4047C42.9375 41.8251 43.4689 41.3418 44.0485 41.3418H53.4171C53.9966 41.3418 54.5281 41.8251 54.5281 42.4047C54.5281 43.0323 53.9966 43.5156 53.4171 43.5156Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6708_2573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 69,
    width: 34,
    height: 13
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2227 69.373H82.3458V81.9994H49.2227V69.373Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6708_2573)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5432 81.9603H52.2561C50.7111 81.9603 49.5039 80.7051 49.5039 79.1601V72.2045C49.5039 70.6595 50.7111 69.4043 52.2561 69.4043H79.5432C81.0895 69.4043 82.3447 70.6595 82.3447 72.2045V79.1601C82.3447 80.7051 81.0895 81.9603 79.5432 81.9603Z",
    fill: "#114A65"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6708_2573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 69,
    width: 34,
    height: 13
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 69.373H33.1219V81.9994H0V69.373Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6708_2573)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0393 81.9603H2.75214C1.25523 81.9603 0 80.7051 0 79.1601V72.2045C0 70.6595 1.25523 69.4043 2.75214 69.4043H30.0393C31.5843 69.4043 32.8408 70.6595 32.8408 72.2045V79.1601C32.8408 80.7051 31.5843 81.9603 30.0393 81.9603Z",
    fill: "#114A65"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8615 61.3358C29.171 61.3358 27.8184 59.9831 27.8184 58.3407C27.8184 56.6502 29.171 55.2988 30.8615 55.2988C32.5039 55.2988 33.8553 56.6502 33.8553 58.3407C33.8553 59.9831 32.5039 61.3358 30.8615 61.3358Z",
    fill: "#EB3D31"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1025 61.3358C36.412 61.3358 35.0605 59.9831 35.0605 58.3407C35.0605 56.6502 36.412 55.2988 38.1025 55.2988C39.7449 55.2988 41.0975 56.6502 41.0975 58.3407C41.0975 59.9831 39.7449 61.3358 38.1025 61.3358Z",
    fill: "#FFD05C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4171 59.4063H44.0485C43.4689 59.4063 42.9375 58.9229 42.9375 58.3434C42.9375 57.7158 43.4689 57.2324 44.0485 57.2324H53.4171C53.9966 57.2324 54.5281 57.7158 54.5281 58.3434C54.5281 58.9229 53.9966 59.4063 53.4171 59.4063Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0849 78.6756C4.44249 78.6756 3.08984 77.323 3.08984 75.6818C3.08984 73.9913 4.44249 72.6387 6.0849 72.6387C7.7754 72.6387 9.12681 73.9913 9.12681 75.6818C9.12681 77.323 7.7754 78.6756 6.0849 78.6756Z",
    fill: "#EB3D31"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3298 78.6756C11.6873 78.6756 10.3359 77.323 10.3359 75.6818C10.3359 73.9913 11.6873 72.6387 13.3298 72.6387C15.0203 72.6387 16.3729 73.9913 16.3729 75.6818C16.3729 77.323 15.0203 78.6756 13.3298 78.6756Z",
    fill: "#FFD05C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6405 76.793H19.32C18.6923 76.793 18.209 76.2628 18.209 75.6832C18.209 75.0544 18.6923 74.5723 19.32 74.5723H28.6405C29.2681 74.5723 29.7515 75.0544 29.7515 75.6832C29.7515 76.2628 29.2681 76.793 28.6405 76.793Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5861 78.6756C53.9437 78.6756 52.543 77.323 52.543 75.6818C52.543 73.9913 53.9437 72.6387 55.5861 72.6387C57.2766 72.6387 58.6293 73.9913 58.6293 75.6818C58.6293 77.323 57.2766 78.6756 55.5861 78.6756Z",
    fill: "#EB3D31"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8317 78.6756C61.1893 78.6756 59.8379 77.323 59.8379 75.6818C59.8379 73.9913 61.1893 72.6387 62.8317 72.6387C64.5222 72.6387 65.8749 73.9913 65.8749 75.6818C65.8749 77.323 64.5222 78.6756 62.8317 78.6756Z",
    fill: "#FFD05C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1405 76.793H68.82C68.1923 76.793 67.709 76.2628 67.709 75.6832C67.709 75.0544 68.1923 74.5723 68.82 74.5723H78.1405C78.7694 74.5723 79.2515 75.0544 79.2515 75.6832C79.2515 76.2628 78.7694 76.793 78.1405 76.793Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiwarehouseSync);
export default __webpack_public_path__ + "static/media/multiwarehouse_sync.84753068df34f89fd770f16017952a04.svg";
export { ForwardRef as ReactComponent };